// extracted by mini-css-extract-plugin
export default {"pin":"DotJapanBg_pin__Fiqru","awaji":"DotJapanBg_awaji__jHDY+","tokyo":"DotJapanBg_tokyo__GRSm1"};